var map = {
	"./symbol_0.png": "f9d9",
	"./symbol_1.png": "1ba9",
	"./symbol_2.png": "a0c6",
	"./symbol_3.png": "53e3",
	"./symbol_4.png": "3500",
	"./symbol_5.png": "95a3",
	"./symbol_6.png": "e415",
	"./symbol_7.png": "c2ef",
	"./symbol_8.png": "9d44",
	"./symbol_9.png": "0484"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "130a";